import { FunnelSimple, X } from '@phosphor-icons/react';
import { Input } from './ui/input';
import { Button } from './ui/button';

export const EMPTY_TX_FILTERS = { from: '', to: '', type: 'all', status: 'all', min: '', max: '' };

const TYPE_OPTIONS = [
  { value: 'all', label: 'Todos los tipos' },
  { value: 'subscription', label: 'Suscripción' },
  { value: 'commission_client', label: 'Comisión Cliente' },
  { value: 'commission_provider', label: 'Comisión Proveedor' },
];

const STATUS_OPTIONS = [
  { value: 'all', label: 'Todos los estados' },
  { value: 'paid', label: 'Pagado' },
  { value: 'pending', label: 'Pendiente' },
  { value: 'failed', label: 'Fallido' },
];

const PAID = ['completed', 'mocked', 'paid', 'succeeded'];

export const applyTxFilters = (txs, f) => txs.filter((t) => {
  const d = t.created_at ? new Date(t.created_at) : null;
  if (f.from && (!d || d < new Date(`${f.from}T00:00:00`))) return false;
  if (f.to && (!d || d > new Date(`${f.to}T23:59:59.999`))) return false;
  if (f.type !== 'all' && t.type !== f.type) return false;
  if (f.status === 'paid' && !PAID.includes(t.status)) return false;
  if (f.status === 'pending' && t.status !== 'pending') return false;
  if (f.status === 'failed' && t.status !== 'failed') return false;
  const amt = Number(t.amount || 0);
  if (f.min !== '' && amt < Number(f.min)) return false;
  if (f.max !== '' && amt > Number(f.max)) return false;
  return true;
});

const selectCls = 'h-10 w-full border border-zinc-300 dark:border-zinc-700 bg-white dark:bg-zinc-900 px-2 sm:px-3 text-xs sm:text-sm normal-case tracking-normal font-normal text-zinc-900 dark:text-zinc-100 rounded-none focus:outline-none focus:ring-2 focus:ring-orange-500';

const Field = ({ label, children }) => (
  <label className="flex flex-col gap-1 text-xs font-medium text-zinc-500 uppercase tracking-wide">
    {label}
    {children}
  </label>
);

export const TransactionFilters = ({ value, onChange, resultCount }) => {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  const active = JSON.stringify(value) !== JSON.stringify(EMPTY_TX_FILTERS);

  return (
    <div className="border border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-900 p-4 space-y-3" data-testid="transaction-filters">
      <div className="flex items-center justify-between gap-2">
        <p className="flex items-center gap-2 text-sm font-semibold text-zinc-800 dark:text-zinc-200">
          <FunnelSimple className="w-4 h-4 text-orange-500" weight="bold" /> Filtros
          <span className="text-xs font-normal text-zinc-500" data-testid="tx-filter-result-count">({resultCount} resultados)</span>
        </p>
        {active && (
          <Button variant="ghost" size="sm" className="rounded-none text-orange-600 h-8" onClick={() => onChange(EMPTY_TX_FILTERS)} data-testid="tx-filter-clear-btn">
            <X className="w-4 h-4 mr-1" /> Limpiar
          </Button>
        )}
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-6 gap-3">
        <Field label="Desde"><Input type="date" value={value.from} onChange={set('from')} className="rounded-none h-10 px-2 text-xs sm:text-sm normal-case tracking-normal font-normal" data-testid="tx-filter-from" /></Field>
        <Field label="Hasta"><Input type="date" value={value.to} onChange={set('to')} className="rounded-none h-10 px-2 text-xs sm:text-sm normal-case tracking-normal font-normal" data-testid="tx-filter-to" /></Field>
        <Field label="Tipo">
          <select value={value.type} onChange={set('type')} className={selectCls} data-testid="tx-filter-type">
            {TYPE_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
        </Field>
        <Field label="Estado">
          <select value={value.status} onChange={set('status')} className={selectCls} data-testid="tx-filter-status">
            {STATUS_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
        </Field>
        <Field label="Monto mín."><Input type="number" min="0" step="0.01" placeholder="$0" value={value.min} onChange={set('min')} className="rounded-none h-10 px-2 text-xs sm:text-sm normal-case tracking-normal font-normal" data-testid="tx-filter-min" /></Field>
        <Field label="Monto máx."><Input type="number" min="0" step="0.01" placeholder="Sin límite" value={value.max} onChange={set('max')} className="rounded-none h-10 px-2 text-xs sm:text-sm normal-case tracking-normal font-normal" data-testid="tx-filter-max" /></Field>
      </div>
    </div>
  );
};
